<header class="landing--header">
  <div class="container">
    <div class="row">
      <div class="col-sm-3 my-auto">
        <a [href]="'https://franchisecenter.sa/' + currentLang + ''" target="_blank" class="logo-wrapper">
          <img class="logo" src="./assets/images/Monshaat-white.svg" alt="monshat" />
          <span>{{'Header.slogan' | translate}}</span>
        </a>
      </div>
      <div class="col-sm-9 my-auto text-right">
        <ul class="left--side">
          <li>
            <a href="javascript:void(0);" (click)="downloadUserManual()" >{{'Header.infoBooks' | translate}}</a>
          </li>
          <li>
            <app-language-switcher [currentLang]="currentLang"></app-language-switcher>
          </li>
          <li>
            <a [routerLink]="currentLang + '/auth'">{{'home.info.steps.secondStep.enterSystem' | translate}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
